import React from "react";
import { Paper, Typography, Grid, Box, Divider } from "@mui/material";

const ViewEmailTemplate = ({ template }) => {
  if (!template) {
    return null;
  }

  // Template type mapping aligned with backend EmailType enum
const templateTypeMap = {
    0: "Not Specified",
    1: "Drinking Water",
    2: "Drinking Water (Non-Regulated)",
    3: "Waste Water",
    4: "Indoor Pool",
    5: "Outdoor Pool",
    6: "Multiple",
    7: "ETK",
    8: "ETK Distributor",
    9: "ETK Wholesale",
    10: "Bathing Beach",
    11: "Bottle Order Sent",
    12: "ETK Received",
    13: "Invoice Sent",
    14: "Sample Receipt",
    15: "Quote",
    16: "Rating"
};


  return (
    <Paper elevation={3} style={{ padding: "16px", marginBottom: "20px" }}>
      <Typography variant="h6" gutterBottom>
        Email Template Details
      </Typography>

      <Grid container spacing={2} style={{ marginBottom: "24px" }}>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            <strong>Template ID:</strong> {template.id || "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            <strong>Template Type:</strong> {templateTypeMap[template.type] || "N/A"}
          </Typography>
        </Grid>
      </Grid>

      <Divider style={{ margin: "24px 0" }} />

      {/* Email Preview Section - Like Inbox */}
      <Box
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#ffffff",
          overflow: "hidden",
        }}
      >
        {/* Email Header */}
        <Box
          style={{
            backgroundColor: "#f5f5f5",
            padding: "16px 20px",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography
                variant="body2"
                style={{
                  color: "#666",
                  fontSize: "13px",
                  marginBottom: "8px",
                }}
              >
                <strong>From:</strong> {template.fromAddress || "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                style={{
                  fontSize: "18px",
                  fontWeight: 500,
                  color: "#202124",
                }}
              >
                {template.subjectLine || "No Subject"}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* Email Body */}
        <Box
          style={{
            padding: "24px 20px",
            backgroundColor: "#ffffff",
            minHeight: "300px",
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
            lineHeight: "1.6",
            color: "#202124",
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: template.bodyHtml || "<p>No content</p>" }} />
        </Box>
      </Box>
    </Paper>
  );
};

export default ViewEmailTemplate;